
<template>
    <div class="tableIngresos">
        
        <vs-alert color="danger" v-if="showSinCampoFormativo && filtros.cicloEscolar == 28">
        <template #title>
            No se cuenta configurado los campos formativos.
        </template>
        </vs-alert>
        <vs-row>
            <vs-col w="12" v-if="JSON.parse(personaRol).tipoUserPrincipal == 'Personal central - TI' || (filtros.institucion == 1)" >

                <vs-button
                    class="ml-auto"
                    warn
                    @click="getActualizarBoletas()"
                    :disabled="selected == ''"
                >
                    <i class="fas fa-sync-alt mr-2"></i> Actualizar boletas
                </vs-button>
            </vs-col>
            <vs-col w="12" v-if="JSON.parse(personaRol).tipoUserPrincipal == 'Personal central - TI'" >
                <vs-button
                    class="ml-auto"
                    @click="getExcelCalificaciones()"
                    :disabled="selected == ''"
                >
                    Descarga de excel
                </vs-button>
            </vs-col>
            <vs-col w="12">
                <div class="text-right">
                    <md-menu>
                        <vs-button
                            :loading="loadingButtons"
                            class="ml-auto"
                            success
                            :disabled="selected == ''"
                            md-menu-trigger
                        >
                            Descargar boleta(s)
                        </vs-button>
                        <md-menu-content>
                            <md-menu-item @click="getCalificacionesAlumno('admin')">Administrador</md-menu-item>
                            <md-menu-item @click="getCalificacionesAlumno('alumno')">Alumno</md-menu-item>
                        </md-menu-content>
                    </md-menu>
                </div>
                <vs-input v-if="users != ''" class="ml-auto searchWidth" v-model="search" placeholder="Buscar">
                    <template #icon>
                        <i class="fas fa-search"></i>
                    </template>
                </vs-input>
                <div style="max-width: 100%;">
                    <h6 class="pl-4 mb-0">Alumnos: {{users.length}}</h6>
                    <vs-table striped clas="table-responsive"  v-dragscroll="{ target: '.vs-table', active: true }">
                        <template #thead>
                        <vs-tr>
                            <vs-th style="width: 10%;">
                                <vs-checkbox
                                    :indeterminate="selected.length == users.length" v-model="allCheck"
                                    @change="selected = $vs.checkAll(selected, users)"
                                />
                            </vs-th>
                            <vs-th>
                                Alumno
                            </vs-th>
                            <vs-th width="50">
                                Salón
                            </vs-th>
                        </vs-tr>
                        </template>
                        <template #tbody>
                        <vs-tr
                            :key="i"
                            v-for="(tr, i) in users"
                            :data="tr"
                        >
                            <vs-td checkbox class="checkAlumno">
                                <vs-checkbox class="m-auto" :val="tr" v-model="selected" />
                            </vs-td>
                            <vs-td>
                                <md-content class="docientos">
                                    <md-chip class="mb-1 fontMedium mini-chip col-blue"><small class="text-uppercase">No. Lista: </small><strong>{{tr.numero_lista}}</strong></md-chip>
                                    <div class="estatus-alumno" :class="coloresEstatus(tr.estatus_registro_academico)" v-if="tr.estatus_registro_academico">
                                        <small><strong>{{tr.estatus_registro_academico}}</strong></small>
                                    </div>
                                    <p class="mb-0"><strong>{{tr.nombre}}</strong></p>
                                    <p class="mb-0"><small class="text-uppercase">Matrícula: </small><strong>{{tr.matricula}}</strong></p>
                                    <vs-button
                                        v-if="tr.persona_id" 
                                        transparent
                                        blank
                                        :href="`/panel/alumno/${window.btoa(tr.persona_id)}/institucion/${window.btoa(tr.institucion_id)}?valor=ver-calificaciones`"
                                    >
                                        <i class="fas fa-address-card mr-2"></i>  Ir a boleta
                                    </vs-button>
                                </md-content>
                            </vs-td>
                            <vs-td>
                                <md-content class="ochenta">
                                    <md-chip class="mb-1 fontMedium mini-chip col-purple"><strong>{{tr.salon}}</strong></md-chip>
                                </md-content>
                            </vs-td>
                        </vs-tr>
                        </template>
                        <template #notFound>
                            No hay información
                        </template>
                    </vs-table>
                </div>
            </vs-col>
        </vs-row>
        <descargar-boleta-campo-formativo ref="boletasCamposFormativos" :nombreArchivo="nombreArchivo" :alumnos="alumnosCalificaciones" :nivel="nivel" :observaciones="observaciones" :filtros="filtros" :institucion="institucion" @loadingBoton="loadingButtons = false"></descargar-boleta-campo-formativo>
    </div>
</template>
<script>
import reportes from '../../../../api/requests/reportes.js'
import TablaCalificaciones from './descarga-boleta.vue'
import boleta from './boleta.vue'
import BoletaCampoFormativo from './descargar-boletas/boleta-campo-formativo.vue'
import BoletaSinCampoFormativo from './descargar-boletas/boleta-sin-campo-formativo.vue'
import alumnos from '../../../../api/requests/alumno'
import DescargarBoletaCampoFormativo from '../../landing/boleta/descargar-boletas/boleta-campo-formativo.vue'
export default {
    props: [
        'users',
        'filtros',
        'personaRol',
        'nivel',
        'institucion',
        'nombreArchivo'
    ],
    data:() => ({
        search: '',
        allCheck: false,
        selected: [],
        infoAlumno: [],
        infoUsers: [],
        usersCalif: [],
        headers: [],
        promedio_materias: [],
        componentKey: 0,
        loadingButtons: false,
        estatusBaja: [],
        observaciones: {},
        alumnosCalificaciones: [],
        showSinCampoFormativo: false
    }),
    components: {
        boleta,
        BoletaCampoFormativo,
        BoletaSinCampoFormativo,
        DescargarBoletaCampoFormativo
    },
    created(){
        this.getEstatusAlumno()
    },
    methods:{
        exportPDF() {
      var vm = this
      var columns = [
        {title: "Title", dataKey: "title"},
        {title: "Description", dataKey: "description"}
      ];
      var doc = new jsPDF('p', 'pt');
      doc.text('To Do List', 40, 40);
      doc.autoTable(columns, vm.todos, {
        margin: {top: 60},
      });
      doc.save('todos.pdf');
    },
        async getEstatusAlumno(){
            try{
                const params = {
                    type: 'baja'
                }
                const {data: response} = await alumnos.getEstatusAlumno(params)
                response.map(r =>{
                    this.estatusBaja.push(r.status)
                })
            }catch(error){
                console.error(error)
            }
        },
        coloresEstatus(estatus){
            if(['Inscrito económico','Reactivación'].includes(estatus)){
                return 'col-green'
            }else if(['Congelado'].includes(estatus)){
                return 'col-yellow'
            }else if(this.estatusBaja.includes(estatus)){
                return 'col-red'
            }else{
                return 'col-blue'
            }
        },
        async getExcelCalificaciones(){
            const loading = this.$vs.loading({
                text: 'Por favor, espere. Esto puede tardar un poco.',
            })
                try {
                    const params = {
                        ciclo_escolar_id:  this.filtros.cicloEscolar,
                        institucion_id: this.filtros.institucion,
                        programa_id: this.filtros.programa
                    }
                    let datos = []
                    for(var x = 0;x < this.selected.length; x++){
                        datos.push(this.selected[x].persona_id)
                    }
                    
                    params.persona_alumno_id = datos
                    params.accion = 'excel_campos'
                    params.campo_formativo = [1,2,3].includes(this.nivel) ? true : false
                    await reportes.getDescargarBoletas(params)
                        .then((response) => {
                            window.location.href = response.request.responseURL;
                        })
                }catch (error) {
                    console.log(error)
                    this.$vs.notification({
                        progress: 'auto',
                        color: 'danger',
                        position: null,
                        title: 'Error',
                        text: 'Hubo un error, favor de contactar al administrador.'
                    })
                        
                }finally{
                    loading.close()
                }
        },
        async getCalificacionesAlumno (tipo) {
            this.tipo_formato = tipo
            const loading = this.$vs.loading({
                text: 'Por favor, espere. Esto puede tardar un poco.',
            })
                try {
                    const params = {
                        ciclo_escolar_id:  this.filtros.cicloEscolar,
                        institucion_id: this.filtros.institucion,
                        programa_id: this.filtros.programa
                    }
                    let datos = []
                    for(var x = 0;x < this.selected.length; x++){
                        datos.push(this.selected[x].persona_id)
                    }
                    
                    params.persona_alumno_id = datos
                    params.accion = 'descarga'
                    params.campo_formativo = [1,2,3].includes(this.nivel) ? true : false
                    await reportes.getDescargarBoletas(params)
                        .then((response) => {
                            this.alumnosCalificaciones = response.data
                            
                            if([1,2,3].includes(this.nivel) && this.alumnosCalificaciones[0].materias_promediables.campos_formativos.materias_sin_campo_formativo[0]){
                                this.showSinCampoFormativo = true
                            }else{
                                this.showSinCampoFormativo = false
                            }
                        })
                        .then(() => {
                            if(this.nivel == 2){
                                this.getObservaciones()
                            }else{
                                this.$refs.boletasCamposFormativos.getCalificaciones(tipo)
                            }
                        })
                }catch (error) {
                    console.log(error)
                    this.$vs.notification({
                        progress: 'auto',
                        color: 'danger',
                        position: null,
                        title: 'Error',
                        text: 'Hubo un error, favor de contactar al administrador.'
                    })
                        
                }finally{
                    loading.close()
                }
        },
        async getObservaciones(){
        if(this.nivel == 2){
            const loading = this.$vs.loading({
                text: 'Estamos obteniendo los datos finales.',
            })
            try{
                const params = {
                    ciclo_escolar_id:  this.filtros.cicloEscolar,
                    institucion_id: this.filtros.institucion,
                    programa_id: this.filtros.programa
                }
                let datos = []
                for(var x = 0;x < this.selected.length; x++){
                    datos.push(this.selected[x].persona_id)
                }
                
                params.persona_alumno_id = datos
                params.accion = 'descarga'
                await reportes.getObservaciones(params)
                .then((response) => {
                    const res = response.data
                    const valores = this.getEliminarNameKey(res)    
                    const alumnos = []
                    for(var i = 0; i < valores.length; i++){
                        const keys = valores[i].periodos ? Object.keys(valores[i].periodos) : ''
                        const value = Object.values(valores[i].periodos)
                        const obj = {
                            "matricula": valores[i].matricula,
                            "nombre_alumno": valores[i].nombre_alumno,
                            "periodos": valores[i].periodos ? Object.values(valores[i].periodos).map((periodo, index) => {
                                return {
                                    "periodo": keys[index],
                                    "campos_formativos": periodo
                                }
                            }) : []
                        }
                        alumnos.push(obj)
                    }
                    this.observaciones = alumnos
                })
                .then(() => {
                    this.$refs.boletasCamposFormativos.getCalificaciones(this.tipo_formato)
                })
                

            }catch(error){
                console.error(error)
            }finally{
                loading.close()
            }
        }
        },
        getEliminarNameKey(info){
            const datos = Object.values(info)
            return datos
        },
        getBoletasHijo(tipo){
            this.loadingButtons = true
            this.$refs.boletasCamposFormativos.getCalificaciones(tipo)
            // if([1,2,3].includes(this.nivel)){
            //     this.$refs.boletasCamposFormativos.getObservaciones(tipo)
            //     this.$refs.boletasCamposFormativos.getCalificaciones(tipo)
            // }else{
            //     this.$refs.boletasSinCampoFormativo.getCalificaciones(tipo)
            // }
            // this.$refs.boletasHijo.getObservaciones(tipo)
            // this.$refs.boletasHijo.getCalificaciones(tipo)
        },
        async getActualizarBoletas(){
            this.contador += 1
            const loading = this.$vs.loading({
                text: 'Por favor, espere. Esto puede tardar un poco.'
            })
            try {
                const params = {
                    ciclo_escolar_id:  this.filtros.cicloEscolar,
                    institucion_id: this.filtros.institucion,
                    programa_id: this.filtros.programa
                }
                let datos = []
                for(var x = 0;x < this.selected.length; x++){
                    datos.push(this.selected[x].persona_id)
                }
                
                params.persona_alumno_id = datos
                params.accion = 'generar'
                this.infoAlumno = []
                this.headers = []
                this.infoUsers = []
                this.informacion = []
                this.materiasCalificaciones = []
                const { data: response } = await reportes.getDescargarBoletas(params)
                    this.$vs.notification({
                        progress: 'auto',
                        color: 'success',
                        position: null,
                        title: 'Operación éxitosa',
                        text: 'Se actualizaron correctamente las boletas.'
                    })
                    loading.close()
                    this.$emit("refresTable")
            } catch (error) {
                console.error(error)
                loading.close()
                this.$vs.notification({
                    progress: 'auto',
                    color: 'danger',
                    position: null,
                    title: 'Error',
                    text: 'Hubo un error, favor de contactar al administrador.'
                })
                    
            }
        },
    },
    watch: {
        filtros(){
            this.selected = []
        }
    }
}
</script>

<style lang="scss" scoped>
    .estatus-alumno{
        display:inline-block;
        // background-color: #007BFF;
        // color:#ffff;
        padding: 3px 15px;
        border-radius: 7px;
        text-transform: uppercase;
    }
    .cardReportes{
        width: 100%;
        background-color:white;
        justify-content: space-between;
        @media only screen and (max-width: 768px) {
            margin: 16px;
        }
        @media only screen and (min-width: 768px) {
            margin: 16px 30px;
        }
        border-radius: 3px;
        padding: 10px
    }
    .searchWidth{
        @media only screen and (max-width: 768px) {
            width: 100%;
        }
        @media only screen and (min-width: 768px) {
            width: 30%;
        }
    }
    .ochenta{
        width: 80px;
        background: none;
        display: inline-flex;
        justify-content: center;
        align-items: center;
    }
    .cien {
        width: 100px;
        background: none;
        display: inline-flex;
        justify-content: center;
        align-items: center;
    }
    .cienCincuenta {
        width: 150px;
        background: none;
        display: inline-flex;
        justify-content: center;
        align-items: center;
    }
    .docientos {
        width: 200px;
        background: none;
        justify-content: center;
        align-items: center;
    }
    .trecientos{
        width: 300px;
        background: none;
        display: inline-flex;
        justify-content: center;
        align-items: center;

    }

    .fs-14{
        font-size: 14px;
        font-weight: 600;
    }

    .mdChip{
        background: rgba($color: #000000, $alpha: 0.5);
        margin:1.7% 0;
        padding: 2% 6%;
        text-align: center;
        border-radius: 15px;
        font-size: 11px;
    }
    .tableIngresos .vs-table__th__content{
        justify-content: center;
    }

    .col-blue{
        color: #2874A6;
        background: rgb(214, 234, 248);
    }

    .col-purple{
        color: purple;
        background: rgb(232, 218, 239);
    }
    
    .tablePDF{
        width: 100%;
        thead{
            border-bottom: 1px solid #F2F3F4;
            background: #F2F3F4;
        }
        thead tr th{
            padding: 10px 0;
        }

        tbody tr{
            border-bottom: 1px solid rgb(207, 207, 207);
        }
        tbody tr td{
            padding: 7px;
        }
        .centrarTexto{
            text-align: center;
        }

    }

</style>
<style scoped>
    .checkAlumno .vs-checkbox-content{
        justify-content: center
    }
    .vs-table{
        overflow-x: none;
    }

    .vs-table__tbody{
        vertical-align: top !important;
    }

    .col-yellow{
        background: rgb(255, 248, 236);
        color: #febf3d;
    }

    .col-red{
        color: #f62d51;
        background: rgb(249, 231, 235);
    }

    .col-green{
        color: #55ce63;
        background: rgb(232, 253, 235);
    }

    .col-purple{
        color: purple;
        background: rgb(232, 218, 239);
    }

    .col-blue{
        color: #2874A6;
        background: rgb(214, 234, 248);
    }

    .col-gray{
        color: #5F6A6A;
        background: rgb(242, 243, 244);
    }

    .col-pink{
        color: #F08080;
        background: rgb(255, 236, 236);
    }

    .col-brown{
        color: #784212;
        background: rgb(250, 229, 211);
    }
    .docientos {
        width: 200px;
        background: none;
        justify-content: center;
        align-items: center;
    }
    .ochenta {
        width: 80px;
        background: none;
        display: inline-flex;
        justify-content: center;
        align-items: center;
    }
    .trecientos{
        width: 300px;
        background: none;
        display: inline-flex;
        justify-content: center;
        align-items: center;

    }
    .on-top{
        margin-top: -120px
    }

</style>

<style>
    .tableIngresos .vs-table__th__content{
        justify-content: center;
    }

</style>
        